// Game enums shared by every package (03 §3.1). Order matters where noted.

export const SYSTEM_TYPES = ['standard', 'resource_rich', 'strategic', 'barren'] as const;
export type SystemType = (typeof SYSTEM_TYPES)[number];

export const RESOURCE_TYPES = ['metal', 'gas', 'supplies'] as const;
export type ResourceType = (typeof RESOURCE_TYPES)[number];

/** The 16 buildings (decision log). Database enum values. */
export const FACILITY_TYPES = [
  'command_center',
  'metal_mine',
  'gas_harvester',
  'supply_farm',
  'metal_storage',
  'gas_storage',
  'supply_storage',
  'trading_port',
  'space_dock',
  'habitat',
  'odp',
  'warp_gate',
  'observatory',
  'space_guild',
  'research_center',
  'diplomatic_embassy',
] as const;
export type FacilityType = (typeof FACILITY_TYPES)[number];

/** Ship classes in combat roll order (GDD 04). */
export const SHIP_TYPES = [
  'interceptor',
  'transport',
  'frigate',
  'cruiser',
  'carrier',
  'battleship',
  'dreadnought',
] as const;
export type ShipType = (typeof SHIP_TYPES)[number];

/** Keys of `baseline.yaml → buildings`; identical to the facility types except the ODP. */
export const BUILDING_KEYS = [
  'command_center',
  'metal_mine',
  'gas_harvester',
  'supply_farm',
  'metal_storage',
  'gas_storage',
  'supply_storage',
  'trading_port',
  'space_dock',
  'habitat',
  'orbital_defense_platform',
  'warp_gate',
  'observatory',
  'space_guild',
  'research_center',
  'diplomatic_embassy',
] as const;
export type BuildingKey = (typeof BUILDING_KEYS)[number];

export function buildingKeyForFacility(facility: FacilityType): BuildingKey {
  return facility === 'odp' ? 'orbital_defense_platform' : facility;
}

export function facilityForBuildingKey(key: BuildingKey): FacilityType {
  return key === 'orbital_defense_platform' ? 'odp' : key;
}
